import { render } from "./FloatingWindow.vue?vue&type=template&id=355a712a&scoped=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"

import "./FloatingWindow.vue?vue&type=style&index=0&id=355a712a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355a712a"]])

export default __exports__